import * as yup from 'yup';
import { LoginByVinPageFormData } from './LoginByVinPageFormData';
import { PersonalIdentitySchema } from '../../modules/login/PersonalIdentitySchema';

export const LoginByVinPageFormSchema: yup.SchemaOf<LoginByVinPageFormData> = yup.object({
  identity: PersonalIdentitySchema,
  vin: yup
    .string()
    .label('VIN / Chassis number')
    .required()
    .matches(/^[0-9a-zA-Z]+$/, '${path} can contain only letters and numbers')
    .max(17),
});
